<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item label="医生姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['name']" placeholder="请输入医生姓名"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="头像" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['heardImg']" placeholder="请输入头像"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="头衔" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['touXian']" placeholder="请输入头衔"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="职称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['title']" placeholder="请输入职称"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="擅长" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['shangChan']" placeholder="请输入擅长"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="性别" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['sex']" placeholder="请输入性别"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="个人简介" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['descDoctor']" placeholder="请输入个人简介"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="电话" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['moile']" placeholder="请输入电话"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="医院" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['hospital']" placeholder="请输入医院"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="科室" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['department']" placeholder="请输入科室"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="省份id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['provinceId']" placeholder="请输入省份id"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="科室id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['departmentId']" placeholder="请输入科室id"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="省份" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['province']" placeholder="请输入省份"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="城市Id" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['cityId']" placeholder="请输入城市Id"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item label="城市" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['city']" placeholder="请输入城市"></a-input>
            </a-form-item>
          </a-col>
          <a-col v-if="showFlowSubmitButton" :span="24" style="text-align: center">
            <a-button @click="submitForm">提 交</a-button>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'

  export default {
    name: 'DoctorInfoTempForm',
    components: {
      JFormContainer,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
validatorRules: {
},
        url: {
          add: "/doctorInfoTemp/doctorInfoTemp/add",
          edit: "/doctorInfoTemp/doctorInfoTemp/edit",
          queryById: "/doctorInfoTemp/doctorInfoTemp/queryById"
        }
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'name','heardImg','touXian','title','shangChan','sex','descDoctor','moile','hospital','department','provinceId','departmentId','province','cityId','city'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit (res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                that.$emit('ok');
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'name','heardImg','touXian','title','shangChan','sex','descDoctor','moile','hospital','department','provinceId','departmentId','province','cityId','city'))
      },
    }
  }
</script>